// Authentication type - string descriptions from AppLookups
export type AuthenticationType = string

// Predefined constants for known auth type descriptions
export const AUTH_TYPE = {
  UsernamePassword: 'Username/Password',
  GoogleSocial: 'Google Social',
  GoogleWorkspace: 'Google Workspace'
} as const

export interface GoogleWorkspaceCredentials {
  clientId: string
  clientSecret: string
  domain: string
  domainAliases?: string[]
}

export interface AddAuthConnectionRequest {
  type: string  // Auth type description string (e.g., "Google Social")
  googleWorkspace?: GoogleWorkspaceCredentials
}

export interface GoogleWorkspaceConfigDto {
  Domain: string
  DomainAliases?: string[]
  ConnectionName: string | null
}

export interface AuthConnectionDto {
  Type: string  // Auth type description string from server
  ConnectionId: string | null
  IsEnabled: boolean
  ConfiguredAt: string | null
  GoogleWorkspace?: GoogleWorkspaceConfigDto
}

export interface UpdateAuthConnectionRequest {
  isEnabled?: boolean
}
